import React, { useState } from 'react';
import { Tooltip } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { FileCopy, OpenInNew, CheckCircle, Link as LinkIcon } from '@material-ui/icons';
import { PrimaryButton, SecondaryButton } from '../../components/AtomComponents';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import { IFederatedLoginResultProps } from './types';

export const FederatedLoginResult: React.FC<IFederatedLoginResultProps> = ({ loginUrl }) => {
  const [copied, setCopied] = useState(false);
  const { openSnackBar } = useDataService();

  const handleCopy = async () => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(loginUrl);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = loginUrl;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      setCopied(true);
      openSnackBar('AWS Login URL copied to clipboard!', eMessageType.success);
      setTimeout(() => setCopied(false), 3000);
    } catch {
      openSnackBar('Failed to copy URL to clipboard', eMessageType.error);
    }
  };

  return (
    <div className="url-result-card">
      <div className="result-header">
        <div className="result-title">
          <CheckCircle className="result-icon-success" />
          <span>AWS Federated Login URL</span>
        </div>
      </div>
      <Alert severity="success" className="margin-bottom-2">
        Your AWS federated login URL is ready. Click the link below or use the Copy URL button.
      </Alert>
      <div className="url-text-box">
        <a href={loginUrl} target="_blank" rel="noopener noreferrer" title="Click to open AWS login URL in a new tab" className="link-to-text">
          <LinkIcon className="link-icon" />
          AWS Federated Login Link
        </a>
      </div>
      <div className="result-actions">
        <Tooltip title={copied ? 'Copied!' : 'Copy full login URL to clipboard'} placement="top" arrow classes={{ popper: 'pxw-tooltip-popper' }}>
          <PrimaryButton onClick={handleCopy} startIcon={<FileCopy />}>
            {copied ? 'Copied to Clipboard!' : 'Copy URL'}
          </PrimaryButton>
        </Tooltip>
        <SecondaryButton onClick={() => window.open(loginUrl, '_blank', 'noopener,noreferrer')} startIcon={<OpenInNew />}>
          Open in AWS Console
        </SecondaryButton>
      </div>
    </div>
  );
};
